import { put, takeEvery } from "redux-saga/effects"
import { request } from "src/engine/modules/session/effects"
import { UPDATE_LIST } from "../actions/types"
import { updateListError, updateListSuccess } from "../actions/creators/update"

// put item to list saga
function* requestUpdate(action) {
  const { basicUrl, id, newItem } = action.config
  try {
    const result = yield request(
      basicUrl,
      {},
      {
        method: `put`,
        body: newItem || [id],
      },
    )
    yield put(updateListSuccess(action, result))
  } catch (error) {
    yield put(updateListError(action, error))
  }
}

export default function* updateSaga() {
  yield takeEvery(UPDATE_LIST, requestUpdate)
}
